/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Canonical in-exam conduct phase (derived, never stored).

Orthogonal to roster readiness (presence + admission + ID + lifecycle +
conduct). Nullable on wire outside the in_exam segment.
 */
export type OralExamConductPhase = (typeof OralExamConductPhase)[keyof typeof OralExamConductPhase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamConductPhase = {
  waiting_for_examiner: 'waiting_for_examiner',
  waiting_for_student: 'waiting_for_student',
  starting_exam: 'starting_exam',
  in_exam: 'in_exam',
} as const;
